/** LAND5 NeoCalcul tutor landing (/l/neocalcul): visible copy, anchors, timings. */
export const NEOCALCUL_LANDING_PATH = '/l/neocalcul';
export const NEOCALCUL_ANCHOR = Object.freeze({
  SETUP: 'neocalcul-reglages', REPORT: 'neocalcul-rapport', NEOPROF: 'neocalcul-neoprof',
});

export const NEOCALCUL_MOTION = Object.freeze({
  notifyMs: 900, peckMs: 1100, openMs: 600, pointMs: 1300,
  // Titles are written word by word; then Néo spotlights the product.
  wordMs: 170, focusMs: 1200,
  // Screen 2: a new wizard page brings its top back on screen before Néo flies.
  pageScrollMs: 600,
  // Screen 1: Néo is the cursor (flies to a key, pecks it, the key is clicked);
  // after a full cycle it rests 30 s on the hero CTA, then the demo replays.
  demoThinkMs: 1600, demoKeyMs: 350, demoRetryMs: 2000, demoRevealMs: 3000, cursorMs: 600, tapMs: 300, restMs: 30000,
});

export const NEOCALCUL_HERO_COPY = Object.freeze({
  badge: 'NeoCalcul',
  title: 'Imagine un outil gratuit qui permet à ton élève de s’entraîner ',
  titleEm: 'en s’amusant !',
  play: 'Jouer',
  note: 'Gratuit · sans compte',
  stageLabel: 'La station NeoCalcul joue une série toute seule',
  demoTag: 'Démo',
  demoLabel: 'Choisir une démo',
  demo: Object.freeze({ fractions: '6e · Fractions', relatifs: '5e · Relatifs', factorisation: '3e · Factorisation' }),
});

export const NEOCALCUL_SETUP_COPY = Object.freeze({
  title: 'Une série sur mesure en quelques clics.',
  lead: 'Exemple en 3e : la vraie station, réglée comme pour ton élève.',
  stageLabel: 'Les réglages de la station NeoCalcul',
  // What Néo says on each wizard page (SETUP_STEP), the visitor doing the clicks.
  say: Object.freeze({
    classe: 'Choisis la classe de ton élève.',
    pick: 'Choisis une ou plusieurs notions.',
    picked: 'C’est noté. Passe à la suite.',
    reglages: 'Chaque notion se règle : quels calculs, combien de questions.',
    niveau: 'Le niveau, un chrono si tu veux. Puis joue, ou partage le lien.',
    partager: 'Son lien : il scanne, il joue, sans compte.',
  }),
});

export const NEOCALCUL_REPORT_COPY = Object.freeze({
  title: 'Ce soir, il joue.',
  titleEm: 'Tu reçois ça.',
  leadPlayed: 'C’est ta partie, telle que ton élève te l’envoie.',
  leadExample: 'Un exemple de rapport, tel que ton élève te l’envoie.',
  example: 'Exemple',
  sender: 'Léa',
  time: '21:47',
  phoneLabel: 'Le téléphone du prof reçoit le rapport de son élève',
  skip: 'Continuer',
});
